<template>
  <div class="activity-cv">
    <div class="activity-cv__heading">
      <h1 class="activity-cv__title page-title">
        Activity CV
      </h1>
      <el-button
        class="activity-cv__button"
        type="primary"
        @click="addActivity"
        v-if="availableActivityTypeDescriptions.length > 0"
      >
      <el-icon><Plus/></el-icon>
      Add activity
      </el-button>
    </div>

    <el-collapse v-model="openedActivities">
      <edit-activity
        v-for="(activity, index) in activityArray"
        :activityData="activity"
        :new-activity-index="index"
        :key="index"
        :is-active="isActivityActive(index)"
        :available-activity-type-descriptions="
          availableActivityTypeDescriptions
        "
        @toggle-activity="toggleActivityOpen"
        @remove-activity="removeActivity"
        @update-data="handleUpdateUserData"
      />
    </el-collapse>
  </div>
</template>

<script>
import { getCurrentUserActivityCV } from '@/api/profile.js';
import { removeArrayElementById } from '@/utils/index.js';
import EditActivity from '@/components/profile/EditActivity.vue';
import { GET_USER_CONTACT_INFO } from '@/store/mutationTypes.js';

export default {
  name: 'EditActivities',
  components: {
    EditActivity,
  },
  data() {
    return {
      openedActivities: [],
      activityArray: [],
    };
  },
  computed: {
    descriptions() {
      return this.$store.state.descriptions;
    },
    availableActivityTypeDescriptions() {
      const { activityArray, descriptions } = this;
      return descriptions.activityType.filter((type) =>
        activityArray.every(
          (activity) => activity.activity.activityId !== type.value,
        ),
      );
    },
  },
  methods: {
    removeArrayElementById,
    async fetchUserActivities() {
      const { data, success } = await getCurrentUserActivityCV();

      if (success) {
        this.activityArray = data.items;
      }
    },
    isActivityActive(index) {
      const { openedActivities } = this;

      if (openedActivities.length > 0) {
        return openedActivities.some((activity) => activity === index);
      }
      return false;
    },
    addActivity() {
      this.activityArray.push({
        activityCVId: null,
        level: {
          description: null,
          value: null,
        },
        story: null,
        activity: {
          activityId: null,
          name: null,
        },
      });
      this.toggleActivityOpen(this.activityArray.length - 1);
    },
    toggleActivityOpen(activityIndex) {
      const { isActivityActive, removeArrayElementById } = this;
      if (isActivityActive(activityIndex)) {
        this.openedActivities = removeArrayElementById(
          this.openedActivities,
          activityIndex,
        );
      } else {
        this.openedActivities.push(activityIndex);
      }
    },
    handleUpdateUserData() {
      this.fetchUserActivities();
    },
    removeActivity(index) {
      if (index !== null) {
        const { activityArray, removeArrayElementById } = this;
        this.activityArray = removeArrayElementById(activityArray, index);
      } else {
        this.fetchUserActivities();
      }
    },
  },
  async created() {
    await this.fetchUserActivities();

    const currentActivityCVId = this.$route.query.activity;
    const currentActivity = this.activityArray.find(
      (activity) => activity.activityCVId === currentActivityCVId,
    );
    if (currentActivity) {
      this.toggleActivityOpen(this.activityArray.indexOf(currentActivity));
    }
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.activity-cv {
  .el-collapse-item__header {
    min-height: unset !important;
  }

  &__heading {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }
  &__button {
  }

  &__title {
    margin: 0;
    margin: var(--global-dimension-size-250) 0 var(--global-dimension-size-200);

    font-weight: normal;
    font-size: var(--font-size-800);
    line-height: 1.6;
  }
}
</style>
